import '../polyfills';
import 'style-loader!../css/base.css';
import 'typeface-pt-sans-narrow';
import { alert, errorAlert, confirm } from 'cadenza/alert';
import share from 'cadenza/share';
import { adaptJavaFontSize, fonts } from 'cadenza/utils/fonts';
import i18n from 'cadenza/utils/i18n';
import logger from 'cadenza/utils/logging';
import encodeResourceURL from 'cadenza/utils/encode-resource-url';
import escapeHTML from 'cadenza/utils/escape-html';

const Disy = window.Disy;
const disyCommons = window.disyCommons;

if (Disy.debug) {
  logger.enableAll(false); // do not persist the log level in localStorage
}

Object.assign(Disy, {
  alert,
  errorAlert,
  confirm,
  share,
  adaptJavaFontSize,
  fonts,
  encodeResourceURL,
  escapeHTML
});

Object.assign(disyCommons, {
  i18n,
  logger
});
